module.exports = __webpack_public_path__ + "assets/exploding_head.14719813a76dea468b26425db930c90e.png";